import React, { memo } from "react";

import { StationView } from "Components/StationView/StationView";
import { StationViewController } from "Pages/StationView/StationViewController";
import { StationsLoader } from "Pages/Stations/Stations.loader";
import { PressedStationIdProvider } from "Components/PressedStationIdContext";

export const StationViewPage = memo(() => {
  return (
    <StationsLoader>
      <PressedStationIdProvider>
        <StationViewController />
        <StationView />
      </PressedStationIdProvider>
    </StationsLoader>
  );
});

StationViewPage.displayName = "StationViewPage";
